import { render, staticRenderFns } from "./ApprovalNodeConfig.vue?vue&type=template&id=4781ff56&scoped=true&"
import script from "./ApprovalNodeConfig.vue?vue&type=script&lang=js&"
export * from "./ApprovalNodeConfig.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalNodeConfig.vue?vue&type=style&index=0&id=4781ff56&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4781ff56",
  null
  
)

export default component.exports